"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const index_js_1 = require("../../../utils/index.js");
const index_js_2 = require("../../../LabeledInput/index.js");
const index_js_3 = require("../../../DatePicker/index.js");
const index_js_4 = require("../../../Buttons/index.js");
const DatePickerInput = (props) => {
    const { onChange, date, parseInput, formatDate, isFromOrTo, selectedDate, ...rest } = props;
    const isDateDisabled = (date) => {
        if (isFromOrTo === 'to') {
            return (0, index_js_1.isBefore)(date, selectedDate);
        }
        else {
            return (0, index_js_1.isBefore)(selectedDate, date);
        }
    };
    const buttonRef = React.useRef(null);
    const [inputValue, setInputValue] = React.useState('');
    React.useEffect(() => {
        if (date && !isNaN(date.valueOf())) {
            setInputValue(formatDate(date));
        }
    }, [date, formatDate]);
    const [isVisible, setIsVisible] = React.useState(false);
    const close = React.useCallback(() => setIsVisible(false), []);
    const onDateSelected = React.useCallback((date) => {
        var _a;
        onChange(date);
        close();
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [close, onChange]);
    const onInputChange = React.useCallback((event) => {
        const value = event.target.value;
        setInputValue(value);
        if (!value) {
            onChange(undefined);
        }
        const parsedDate = parseInput(value);
        if (parsedDate && !isNaN(parsedDate.valueOf())) {
            onChange(parsedDate);
        }
    }, [onChange, parseInput]);
    return (React.createElement(index_js_1.Popover, { content: React.createElement(index_js_3.DatePicker, { date: date, onChange: onDateSelected, setFocus: true, isDateDisabled: isDateDisabled }), placement: 'bottom', visible: isVisible, onClickOutside: (_, e) => {
            var _a;
            if (!((_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                close();
            }
        }, appendTo: 'parent' },
        React.createElement(index_js_2.LabeledInput, { displayStyle: 'inline', value: inputValue, onChange: onInputChange, onClick: close, svgIcon: React.createElement(index_js_4.IconButton, { styleType: 'borderless', onClick: () => setIsVisible((v) => !v), ref: buttonRef },
                React.createElement(index_js_1.SvgCalendar, null)), ...rest })));
};
exports.default = DatePickerInput;
